import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-info-icon',
    templateUrl: './info-icon.component.html',
    styleUrls: ['./info-icon.component.scss'],
    standalone: false
})
export class InfoIconComponent{

  @Input() header: string;
  @Input() mainContent: string;
  @Input() isAbove: boolean;
  @Input() isCentered: boolean;
  @Input() marginValue: number;

  isInfoVisible = false;
  isClicked = false;

  showInfo() {
    if (!this.isClicked) this.isInfoVisible = !this.isInfoVisible;
  }

  persistInfo() {
    this.isClicked = !this.isClicked;
  }

  calculateMarginTop() {
    if (this.isAbove) {
      return '-' + (this.marginValue + 3.7) + 'rem';
    } else {
      return this.marginValue + 'rem';
    }
  }

}
